import { IconProps } from "models"

const CardWaveIcon: React.FC<IconProps> = ({
	className = "",
	style = null,
	color = "currentColor",
	width = "290",
	height = "115",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 290 115"
			className={className}
			style={style}
			width={width}
			height={height}
			aria-hidden="true"
		>
			<path
				fill={color}
				d="M290 15a15 15 0 00-15-15H15A15 15 0 000 15v70.256c19.93-5.471 46.333-9.152 74.335-3.151C130.547 94.151 201.8 128.933 290 102.859z"
			/>
		</svg>
	)
}

export default CardWaveIcon
